import { apiClient } from './apiClient';

export type JobPositionAttribution = {
  id: string;
  jobPositionId: string;
  jobLevel: string;
  kindId: string;
  kindName: string;
  title: string;
  description: string;
  sortOrder: number;
  isActive: boolean;
};

export type JobPositionAttributionUpsertPayload = {
  jobLevel: string;
  kindId: string;
  title: string;
  description?: string;
  sortOrder?: number;
  isActive?: boolean;
};

export async function listJobPositionAttributions(
  jobPositionId: string,
  jobLevel?: string,
): Promise<JobPositionAttribution[]> {
  const response = await apiClient.get<JobPositionAttribution[]>(
    `/v1/people/job-positions/${jobPositionId}/attributions`,
    { params: { jobLevel: jobLevel || undefined } },
  );
  return response.data;
}

export async function createJobPositionAttribution(
  jobPositionId: string,
  payload: JobPositionAttributionUpsertPayload,
): Promise<JobPositionAttribution> {
  const response = await apiClient.post<JobPositionAttribution>(
    `/v1/people/job-positions/${jobPositionId}/attributions`,
    payload,
  );
  return response.data;
}

export async function updateJobPositionAttribution(
  jobPositionId: string,
  id: string,
  payload: JobPositionAttributionUpsertPayload,
): Promise<JobPositionAttribution> {
  const response = await apiClient.put<JobPositionAttribution>(
    `/v1/people/job-positions/${jobPositionId}/attributions/${id}`,
    payload,
  );
  return response.data;
}

export async function deleteJobPositionAttribution(
  jobPositionId: string,
  id: string,
): Promise<void> {
  await apiClient.delete(`/v1/people/job-positions/${jobPositionId}/attributions/${id}`);
}
